import base from './base';
import axios from "axios";

export default class extends base {
    static get uri() {
        return 'statistic';
    }

    static overall(params = {}) {
        return axios.get(`${this.uri}/overall`, {
            params
        });
    }

    static cards(params = {}) {
        return axios.get(`${this.uri}/cards`, {
            params
        });
    }

    static cardsByType(params = {}) {
        return axios.get(`${this.uri}/cards-by-type`, {
            params
        });
    }

    static visits(params = {}) {
        return axios.get(`${this.uri}/visits`, {
            params
        });
    }

    static activeCards(params = {}) {
        return axios.get(`${this.uri}/active_cards`, {
            params
        });
    }
}
